// auth
export const LOGIN = '/login'
export const FORGOT_PASSWORD = '/forgot-password'
export const RESET_PASSWORD = '/reset-password'
export const REGISTER = '/register'

export const PROFILE = '/profile'
export const DASHBOARD = '/dashboard'

// Users
export const USERS = '/users'

// Occupants
export const OCCUPANT = `${USERS}/occupants`
export const OCCUPANTS_LIST = `${OCCUPANT}/list`
export const PENDING_OCCUPANTS_LIST = `${OCCUPANT}/pending`
export const OCCUPANTS_CREATE = `${OCCUPANT}/create`
export const OCCUPANTS_EDIT_BASE = `${OCCUPANT}/update`
export const OCCUPANTS_EDIT = `${OCCUPANTS_EDIT_BASE}/:id`
export const OCCUPANTS_VIEW_BASE = `${OCCUPANT}/view`
export const OCCUPANTS_VIEW = `${OCCUPANTS_VIEW_BASE}/:id`

// Guards
export const GUARDS = `${USERS}/guards`
export const GUARDS_LIST = `${GUARDS}/list`
export const GUARDS_CREATE = `${GUARDS}/create`
export const GUARDS_EDIT_BASE = `${GUARDS}/update`
export const GUARDS_EDIT = `${GUARDS_EDIT_BASE}/:id`

// Admins
export const ADMINS = `${USERS}/admin`
export const ADMINS_LIST = `${ADMINS}/list`
export const ADMINS_CREATE = `${ADMINS}/create`
export const ADMINS_EDIT_BASE = `${ADMINS}/update`
export const ADMINS_EDIT = `${ADMINS_EDIT_BASE}/:id`

// Technicians
export const TECHNICIANS = `${USERS}/technicians`
export const TECHNICIANS_LIST = `${TECHNICIANS}/list`
export const TECHNICIANS_CREATE = `${TECHNICIANS}/create`
export const TECHNICIANS_EDIT_BASE = `${TECHNICIANS}/update`
export const TECHNICIANS_EDIT = `${TECHNICIANS_EDIT_BASE}/:id`

// Vendors
export const VENDORS = `${USERS}/vendor`
export const VENDORS_LIST = `${VENDORS}/list`
export const CREATE_VENDORS = `${VENDORS}/create`
export const EDIT_VENDORS_BASE = `${VENDORS}/update`
export const EDIT_VENDORS = `${EDIT_VENDORS_BASE}/:id`

// Visitors
export const VISITORS = `${USERS}/visitors`
export const VISITORS_QR_CODE = `${VISITORS}/qr-applied-list`

// Society Structure
export const SOCIETY_STRUCTURE = '/society-structure'
export const SOCIETY_STRUCTURE_UPLOAD = `${SOCIETY_STRUCTURE}/upload`
export const SOCIETY_STRUCTURE_PROPERTIES = `${SOCIETY_STRUCTURE}/properties`

// Societies
export const SOCIETIES = '/societies'
export const SOCIETIES_LIST = `${SOCIETIES}/list`
export const SOCIETIES_CREATE = `${SOCIETIES}/create`
export const SOCIETIES_EDIT_BASE = `${SOCIETIES}/update`
export const SOCIETIES_EDIT = `${SOCIETIES_EDIT_BASE}/:id`

//Brands Ads
export const BRANDS_ADS = '/brands-ads'
export const BRANDS_ADS_LIST = `${BRANDS_ADS}/list`
export const BRANDS_ADS__CREATE = `${BRANDS_ADS}/create`
export const BRANDS_ADS_EDIT_BASE = `${BRANDS_ADS}/update`
export const BRANDS_ADS__EDIT = `${BRANDS_ADS_EDIT_BASE}/:id`

// Announcements
export const ANNOUNCEMENTS = '/announcements'
export const ANNOUNCEMENTS_LIST = `${ANNOUNCEMENTS}/list`
export const ANNOUNCEMENTS_CREATE = `${ANNOUNCEMENTS}/create`
export const ANNOUNCEMENTS_EDIT_BASE = `${ANNOUNCEMENTS}/update`
export const ANNOUNCEMENTS_EDIT = `${ANNOUNCEMENTS_EDIT_BASE}/:id`

// Entry / Exit Logs
export const ENTRY_EXIT_LOGS = '/entry-exit-logs'
export const ENTRY_EXIT_LOGS_LIST = `${ENTRY_EXIT_LOGS}/list`

// Invoices
export const INVOICES = '/invoices'
export const INVOICES_LIST = `${INVOICES}/list`
export const INVOICES_CREATE = `${INVOICES}/create`
export const INVOICES_EDIT_BASE = `${INVOICES}/update`
export const INVOICES_EDIT = `${INVOICES_EDIT_BASE}/:id`

// Complaints
export const COMPLAINTS = '/complaints'
export const COMPLAINTS_LIST = `${COMPLAINTS}/list`
export const COMPLAINTS_CREATE = `${COMPLAINTS}/create`
export const COMPLAINTS_EDIT_BASE = `${COMPLAINTS}/update`
export const COMPLAINTS_EDIT = `${COMPLAINTS_EDIT_BASE}/:id`

// Ads
export const ADS = '/ads'
export const ADS_LIST = `${ADS}/list`
export const ADS_CREATE = `${ADS}/create`
export const ADS_EDIT_BASE = `${ADS}/update`
export const ADS_EDIT = `${ADS_EDIT_BASE}/:id`

// Brands Ads
export const BRANDADS = '/brandAds'
export const BRANDADS_LIST = `${BRANDADS}/list`
export const BRANDADS_CREATE = `${BRANDADS}/create`
export const GET_BRANDADS_DETAIL = `${BRANDADS}/update`
export const BRANDADS_EDIT = `${GET_BRANDADS_DETAIL}/:id`

// BRAND
export const BRANDS = '/brands'
export const BRANDS_LIST = `${BRANDS}/list`
export const BRANDS_CREATE = `${BRANDS}/create`
export const GET_BRAND_DETAIL = `${BRANDS}/update`
export const BRAND_EDIT = `${GET_BRAND_DETAIL}/:id`

// Emails
export const EMAILS = '/emails'
export const EMAILS_LIST = `${EMAILS}/list`

// Push Notifications
export const PUSH_NOTIFICATIONS = '/push-notifications'
export const PUSH_NOTIFICATIONS_LIST = `${PUSH_NOTIFICATIONS}/list`

// Survey
export const SURVEYS = '/surveys'
export const SURVEYS_LIST = `${SURVEYS}/list`
export const SURVEYS_CREATE = `${SURVEYS}/create`
export const SURVEYS_EDIT_BASE = `${SURVEYS}/update`
export const SURVEYS_ANSWER = `${SURVEYS}/answer`
export const SURVEYS_ANSWER_BASE = `${SURVEYS_ANSWER}/:id`
export const SURVEYS_EDIT = `${SURVEYS_EDIT_BASE}/:id`
export const SURVEYS_VIEW_BASE = `${SURVEYS}/view`
export const SURVEYS_VIEW = `${SURVEYS_VIEW_BASE}/:id`

export const TICKETS = '/tickets'
export const TICKETS_LIST = `${TICKETS}/list`
export const TICKETS_CREATE = `${TICKETS}/create`
export const TICKETS_EDIT_BASE = `${TICKETS}/update`
export const TICKETS_EDIT = `${TICKETS_EDIT_BASE}/:id`

//Service Categories
export const SERVICE_CATEGORY = '/service-category'
export const SERVICE_CATEGORY_LIST = `${SERVICE_CATEGORY}/list`
export const SERVICE_CATEGORY_CREATE = `${SERVICE_CATEGORY}/create`
export const GET_SERVICE_CATEGORY_DETAIL = `${SERVICE_CATEGORY}/update`
export const SERVICE_CATEGORY_EDIT = `${GET_SERVICE_CATEGORY_DETAIL}/:id`

//Service
export const SERVICE = '/service'
export const SERVICELIST = `${SERVICE}/list`
export const CREATE_SERVICE = `${SERVICE}/create`
export const GET_SERVICE_DETAIL = `${SERVICE}/update`
export const EDIT_SERVICE = `${GET_SERVICE_DETAIL}/:id`
export const GET_OCCUPANTS_SERVICES_DETAIL = `${SERVICE}/occupants/list`
export const GET_OCCUPANTS_SERVICE = `${GET_OCCUPANTS_SERVICES_DETAIL}/:id`

export const BOOKING = '/Booking'
export const BOOKING_LIST = `${BOOKING}/list`
export const BOOKING_CREATE = `${BOOKING}/create`
export const GET_BOOKING_DETAIL = `${BOOKING}/update`
export const EDIT_BOOKING = `${GET_BOOKING_DETAIL}/:id`

// Panic Queries
export const PANIC_QUERIES = '/panic-queries'
export const PANIC_QUERIES_LIST = `${PANIC_QUERIES}/list`
